import { useStaticQuery, graphql } from 'gatsby'
import dedupe from 'dedupe'

export const useBlogAuthors = () => {
  const { allBlogAuthor } = useStaticQuery(authorsQuery)
  return allBlogAuthor.nodes
    ? dedupe(allBlogAuthor.nodes, node => node.slug)
    : null
}

const authorsQuery = graphql`
  query allBlogAuthorQuery {
    allBlogAuthor {
      nodes {
        ...BlogAuthor
      }
    }
  }
`
